import { render, staticRenderFns } from "./add_bccl.vue?vue&type=template&id=7deb82f9&scoped=true&"
import script from "./add_bccl.vue?vue&type=script&lang=js&"
export * from "./add_bccl.vue?vue&type=script&lang=js&"
import style0 from "./add_bccl.vue?vue&type=style&index=0&id=7deb82f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb82f9",
  null
  
)

export default component.exports